import * as types from './mutation-types'

export default {
    [types.EVENT_BADGE_TEMPLATE] (state, data) {
        state.eventBadgeTemplate = data
    },
}
